// sitemap.ts
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  Icon,
  UilChartPie,
  UilCube,
  UilDocumentLayoutRight,
  UilFilesLandscapesAlt,
  UilPuzzlePiece,
  UilSignout
} from '@iconscout/react-unicons';

import { UserRole } from 'store/authSlice';

export interface Route {
  name: string;
  icon?: IconProp | string | string[];
  iconSet?: 'font-awesome' | 'feather' | 'unicons';
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
  next?: boolean;
  roles?: UserRole[];
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
  roles?: UserRole[];
}

export const routes: RouteItems[] = [
  {
    label: 'dashboard',
    horizontalNavLabel: 'home',
    active: true,
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      {
        name: 'Dashboard',
        icon: 'pie-chart',
        path: '/',
        active: true,
        flat: true,
        hasNew: true,
        roles: ['super_user', 'company_admin', 'user']
      }
    ],
    roles: ['super_user', 'company_admin', 'user']
  },
  {
    label: 'Company Management',
    icon: UilCube,
    pages: [
      {
        name: 'Companies',
        icon: 'grid',
        path: '/companies',
        pathName: 'companies',
        active: true,
        roles: ['super_user']
      }
    ],
    roles: ['super_user', 'company_admin', 'user']
  },
  {
    label: 'Asset Management',
    icon: UilCube,
    pages: [
      {
        name: 'My Devices',
        icon: 'monitor',
        path: '/my-devices',
        pathName: 'my-devices',
        active: true,
        roles: ['super_user', 'company_admin', 'user']
      },
      {
        name: 'All Assets',
        icon: 'archive',
        path: '/all-assets',
        pathName: 'all-assets',
        active: true,
        roles: ['super_user', 'company_admin']
      },
      {
        name: 'Categories',
        icon: 'server',
        path: '/categories',
        pathName: 'Category',
        active: true,
        roles: ['super_user', 'company_admin']
      }
    ],
    roles: ['super_user', 'company_admin', 'user']
  },
  {
    label: 'User Management',
    icon: UilDocumentLayoutRight,
    active: true,
    pages: [
      {
        name: 'User List',
        icon: 'user-check',
        path: '/user-list',
        pathName: 'users-list',
        active: true,
        roles: ['super_user', 'company_admin']
      },
      {
        name: 'Department Managements',
        icon: 'layers',
        path: '/department-management',
        pathName: 'Department Managements',
        active: true,
        roles: ['super_user', 'company_admin']
      }
    ],
    roles: ['super_user', 'company_admin']
  },
  {
    label: 'Request Management',
    icon: UilFilesLandscapesAlt,
    pages: [
      {
        name: 'My Requests',
        icon: 'clipboard',
        path: '/my-requests',
        pathName: 'my-requests',
        active: true,
        roles: ['company_admin', 'user']
      },
      {
        name: 'All Requests',
        icon: 'bookmark',
        path: '/all-requests',
        pathName: 'all-requests',
        active: true,
        roles: ['super_user', 'company_admin']
      }
    ],
    roles: ['super_user', 'company_admin', 'user']
  },
  {
    label: 'Approvels',
    active: true,
    icon: UilPuzzlePiece,
    megaMenu: true,
    pages: [
      {
        name: 'Pending Approvals',
        icon: 'alert-circle',
        path: '/pending-approvals',
        pathName: 'pending-approvals',
        active: true,
        roles: ['super_user', 'company_admin']
      },
      {
        name: 'Purchase Pending',
        icon: 'check-circle',
        path: '/purchase-pending',
        pathName: 'purchase-pending',
        active: true,
        roles: ['super_user', 'company_admin']
      }
    ],
    roles: ['super_user', 'company_admin']
  },

  {
    label: 'Logout',
    icon: UilSignout,
    active: true,
    pages: [
      {
        name: 'Logout',
        icon: 'log-out',
        path: '/sign-out',
        pathName: 'logout',
        active: true,
        flat: true,
        roles: ['super_user', 'company_admin', 'user']
      }
    ],
    roles: ['super_user', 'company_admin', 'user']
  }
];
